import React from 'react';

const ShippingPolicy = () => {
  return (
    <div className="policy-page">
      <h1>Shipping Policy</h1>
      <p>
        ClevSheetsAI is a digital service. No physical products are shipped.
      </p>
    </div>
  );
};

export default ShippingPolicy;
